export enum VideoType {
  MainStage = 'main stage',
  Session = 'session',
  Poster = 'poster',
}
